// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1WnD2","title":"Images90_title__SSAhY","images":"Images90_images__w0VOn"};